import React from "react";

const CustomText = ({ style, text }) => {
  return <span style={{ ...styles.text, ...style }}>{text}</span>;
};
const styles = {
  text: {
    fontSize: "14px",
    color: "#000000",
  },
};

export default CustomText;
